<form [formGroup]="form">
  <p-card header="Load Information">
    <div class="p-grid">
      <div class="form-group p-col-12 p-xl-6">
        <label [class.required]="supplierBOLRequired" for="supplierBOLNum">Supplier BOL Number</label>
        <div class="p-inputgroup">
          <input formControlName="vendorBolNumber" id="vendorBolNumber" pInputText type="text"/>
          <button (click)="getBolNumber()" [disabled]="requestingBolNumber"
                  [icon]="requestingBolNumber ? 'pi pi-spin pi-spinner' : ''" id="genbol" label="Generate"
                  pButton type="button"></button>
        </div>
        <error-block
          [field]="form.controls.vendorBolNumber"
          [messages]="{
            required: 'Supplier BOL Number is required.',
            numberInUse: 'Reference # is already in use.'
          }">
        </error-block>
      </div>
      <div class="form-group p-col-12 p-xl-6">
        <label class="required" for="trailerId">Trailer</label>
        <app-trailer-select
          inputId="trailerId"
          name="trailerId"
          formControlName="trailerId"
          eligibleFor="unloading"
          [siteSubinventoryId]="(_load | async)?.siteSubinventoryId"
          [carrier]="(_load | async)?.carrier">
        </app-trailer-select>
        <error-block [field]="form.controls.trailerId" [messages]="{
          required: 'Trailer is required.'
        }">
        </error-block>
      </div>
    </div>
    <div class="p-grid">
      <div class="form-group p-col-12 p-xl-6">
        <label class="required">Shift Unloaded</label>
        <app-worked-shift-selector
          [disabled]="form.disabled"
          formControlName="unloadedShiftId"
          (dateSelected)="onUnloadedShiftDateChanged($event)">
        </app-worked-shift-selector>
        <error-block
          [field]="form.controls.unloadedShiftId"
          [messages]="{
            required: 'Unloaded Shift is required.'
          }">
        </error-block>
      </div>

      <div class="form-group p-col-12 p-xl-6">
        <label class="required" for="unloadedTime">Date/Time Unloaded</label>
        <div class="p-inputgroup">
          <p-calendar formControlName="unloadedDate" inputId="unloadedDate" name="unloadedDate" appendTo="body"></p-calendar>
          <time-entry formControlName="unloadedTime" inputId="unloadedTime" [timezone]="siteTimezone" [displaySeconds]="false"></time-entry>
        </div>
        <error-block
          [field]="form.controls.unloadedDate"
          [messages]="{
            required: 'Date Unloaded is required.'
          }"></error-block>
        <error-block
          [field]="form.controls.unloadedTime"
          [messages]="{
            required: 'Time Unloaded is required.'
          }"></error-block>
        <error-block
          [field]="form"
          [messages]="{
            timeSequence: 'Unload Time must be after Check-in Time.',
            datediff: 'Unload Timestamp must be on same day as Unload Shift'
          }"></error-block>
      </div>
    </div>
  </p-card>

  <p-card header="Exceptions">
    <div class="p-grid">
      <div class="form-group p-col-3">
        <label for="isRejected">Site Rejected</label>
        <p-checkbox [binary]="true" formControlName="isRejected" inputId="isRejected" name="isRejected">
        </p-checkbox>
      </div>
      <div class="form-group p-col-9" *ngIf="form.controls.isRejected.value">
        <label for="rejectedBolNumber">Rejected BOL Number</label>
        <input formControlName="rejectedBolNumber" id="rejectedBolNumber" name="rejectedBolNumber" pInputText type="text"/>
      </div>
    </div>
    <div class="p-grid">
      <div *ngIf="form.controls.isRejected.value" class="p-col-12">
        <p-message severity="warn" text="Only use this if load is from your site."></p-message>
      </div>
    </div>
    <div class="p-grid">
      <div class="form-group p-col-3">
        <label for="redTagFlag">Red Tag</label>
        <p-checkbox [binary]="true" formControlName="redTagFlag" inputId="redTagFlag" name="redTagFlag"></p-checkbox>
      </div>
      <div class="form-group p-col-9" *ngIf="form.controls.redTagFlag.value">
        <label for="redTagReason">Reason</label>
        <input formControlName="redTagReason" id="redTagReason" name="redTagReason" pInputText type="text"/>
      </div>
    </div>
  </p-card>

  <div class="form-buttons">
    <button pButton type="submit"
      label="Unload Load"
      [icon]="updating ? 'pi pi-spin pi-spinner' : 'pi pi-arrow-right'"
      [disabled]="updating"
      (click)="unloadLoad()"
      [ngClass]="{'p-state-disabled': !form.valid, 'p-button-success': true }">
    </button>
  </div>
</form>
